import { Image, Typography } from 'antd';
import moment from 'moment';
import React from 'react';

import type { MessageType } from '../types';
import styles from './index.module.scss';

const Message: React.FC<{ message: MessageType }> = ({ message }) => {
  return (
    <div
      className={`${styles.message} ${
        message.type === 'send' ? styles.right : styles.left
      }`}
    >
      <Typography.Text type="secondary">{message.author}</Typography.Text>
      <div className={styles.content}>
        {message.content.type === 'text' && (
          <Typography.Text>{message.content.text}</Typography.Text>
        )}
        {message.content.type === 'image' && (
          <Image src={message.content.image} />
        )}
      </div>
      <Typography.Text type="secondary">
        {moment(message.time).format('YY-MM-DD HH:mm')}
      </Typography.Text>
    </div>
  );
};

export default Message;
